import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const CanonicalTag = () => {
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
